var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',{attrs:{"showTrialPeriodBar":false}},[_c('common-content-spacer',{attrs:{"height":"medium"}},[_c('common-page-header',{attrs:{"heading":_vm.pageTitle}}),_c('common-page-plain',[_c('common-content-wrapper',{attrs:{"width":"small"}},[_c('accident-intake-wizard')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }